/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function CloudSun(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M156,72a75.81,75.81,0,0,0-20.23584,2.73853,55.73208,55.73208,0,0,0-9.41089-11.57911l9.48413-13.54419A8.00015,8.00015,0,0,0,122.731,40.4375l-9.48413,13.54419A55.868,55.868,0,0,0,86.251,48.01953L83.37451,31.70605A7.99987,7.99987,0,1,0,67.61768,34.4834l2.87475,16.30371A55.397,55.397,0,0,0,47.17651,65.635L33.61426,56.13867A8.00027,8.00027,0,0,0,24.4375,69.24609l13.55981,9.49463a55.39532,55.39532,0,0,0-5.98669,26.98535l-16.305,2.87452a8.00079,8.00079,0,0,0,1.37988,15.87988,8.12832,8.12832,0,0,0,1.39844-.12207l16.31079-2.87573a55.95086,55.95086,0,0,0,5.85571,12.42749A51.96741,51.96741,0,0,0,76,224h80a76,76,0,0,0,0-152ZM48.62964,111.09448c-.00879-.05713-.01123-.11352-.02124-.17065-.011-.0625-.02954-.12158-.042-.18335A39.72794,39.72794,0,0,1,55.12793,81.186c.0354-.04834.07642-.08985.11084-.13916.03857-.05518.06909-.11329.106-.16895a39.72789,39.72789,0,0,1,25.48584-16.2395c.07422-.011.148-.01612.22216-.029.06983-.01221.136-.033.20508-.04688a39.95749,39.95749,0,0,1,29.17383,6.28857c.16138.13282.32336.26514.49756.38721.12671.08887.26294.15161.39282.23193a39.78776,39.78776,0,0,1,9.26489,9.31006,76.44756,76.44756,0,0,0-35.5498,40.00293A52.31117,52.31117,0,0,0,76,120a51.67572,51.67572,0,0,0-22.07556,4.93262A40.03451,40.03451,0,0,1,48.62964,111.09448Z" />
    </Svg>
  );
}

export default CloudSun;
